/* eslint-disable react/prop-types */
import clsx from 'clsx'
import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { getFinalValuesFromTaskParameterFunction } from '../config'
import states from '../states.json'

// Generic footer for integration modals
function GenericModalFooter(props) {
  const {
    state,
    action,
    onCancel,
    onActionSubmit, // This is only used if a GenericFormWrapper is used, otherwise the Ref to the GenericFormikWrapper handleSubmit is used for form validation
    taskParameters, // This may be a callback function, or the final task parameters depending on the action
    setTaskParameters,
    submitVariant,
    submitButtonClass,
    submitButtonLangId, // The general submit button language identifier loaded from the data loader specified in the config
    actionData, // Data from the render body
    values, // Values from the formik component
    selectedEmployee,
    disableSubmit,
    handleSubmit,
    formikRef, // Internal reference to the action-components formik component
  } = props

  // Object containing all possible values needed for any taskParameter callback function (getFinalValuesFromTaskParameterFunction in config.js). Build out as needed
  const taskParameterFields = {
    selectedEmployee,
    values,
    actionData,
  }

  const submitButtonStyle = { paddingLeft: '2.5rem', paddingRight: '2.5rem' }

  // No footer during loading
  if (state === states.LOADING) {
    return
  }

  // eslint-disable-next-line consistent-return
  return (
    <Modal.Footer className="bottom">
      {/* Close Modal Button */}
      <Button
        onClick={onCancel}
        variant="light"
        className={`${clsx({
          'pull-left': state === states.RENDER,
          'pull-right': state === states.SUCCESS || state === states.ERROR,
        })}`}
      >
        <FormattedMessage id="GENERAL.CLOSE" />
      </Button>

      {/* Submit Modal Button */}
      {state === states.RENDER && (
        <Button
          onClick={() => {
            // Check if action has passed a handleSubmit. This is generally used for actions with multiple tabs, and we are transitioning from one tab to the next
            if (handleSubmit) {
              // Trigger it
              handleSubmit()
              return
            }

            let finalTaskParameters = taskParameters

            // If an action-component set data for the task parameters, taskParameters will be a callback set within the config (getTaskParameters() in config.js)
            if (typeof finalTaskParameters === 'function') {
              try {
                finalTaskParameters = getFinalValuesFromTaskParameterFunction(
                  action,
                  finalTaskParameters,
                  taskParameterFields,
                )
              } catch (error) {
                console.error(error)
              }
              setTaskParameters(finalTaskParameters) // Set the final task parameters in case it is used within the handleSubmit of Formik
            }

            // The action-component uses a Formik component, so submit using the reference to its submit handler
            if (formikRef?.current) {
              formikRef.current.handleSubmit()
            } else {
              // The action-component is just using a form, so submit the task directly
              onActionSubmit(action, finalTaskParameters)
            }
          }}
          disabled={disableSubmit}
          variant={submitVariant || 'secondary'}
          className={submitButtonClass || 'bg-color-engage pull-right'}
          style={submitButtonStyle}
          id={`${action}-submit-btn`}
        >
          <FormattedMessage id={submitButtonLangId || 'GENERAL.SAVE_CHANGES'} />
        </Button>
      )}
    </Modal.Footer>
  )
}

export default GenericModalFooter
